export default __webpack_public_path__ + "static/media/AMZN.180be8e9.png";